import { createRoot } from "react-dom/client";
import { inject } from "@vercel/analytics";
import { initSentry } from "./lib/sentry-frontend";
import App from "./App.tsx";
import "./index.css";

initSentry();
inject();

createRoot(document.getElementById("root")!).render(<App />);
